import { useMemo } from 'react';

import { isReply } from 'hb-react/frontoffice/apps/CommentsV2/utils';
import { useDefaultAppContexts } from 'hb-react/frontoffice/contexts/withDefaultAppContexts';
import { axiosInstance as axios } from 'hb-react/shared/utils/axios';

const commentsClient = (userId) => {
  const getComments = ({
    commentableId,
    commentableType,
    sortBy,
    page,
    perPage,
  }) => {
    const params = {
      commentable_id: commentableId,
      commentable_type: commentableType,
      sort_by: sortBy,
    };

    // Fetching comments
    if (!isReply(commentableType)) {
      if (page && perPage) {
        params.comments_page = page;
        params.comments_per_page = perPage;
      }

      return axios
        .get(Routes.user_comments_path(userId), {
          params,
        })
        .then((res) => res.data);
    }

    // Fetching replies
    if (page && perPage) {
      params.replies_page = page;
      params.replies_per_page = perPage;
    }

    return axios
      .get(Routes.replies_user_comments_path(userId), {
        params,
      })
      .then((res) => res.data);
  };

  return { getComments };
};

export const useCommentsClient = () => {
  const { currentUser } = useDefaultAppContexts();

  const { id } = currentUser;

  return useMemo(() => commentsClient(id), [id]);
};
